import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import ar from "../locales/ar";
import en from "../locales/en";
import fr from "../locales/fr";

export const resources = {
    en,
    ar,
    fr,
};

// this is crucial if we want default language to be set by the browser language
// const detection = {
//   order: ['querystring', 'navigator'],
//   lookupQuerystring: 'lng',
// };
// i18next.use(LanguageDetector).init({ detection, resources, defaultNS, fallbackLng: 'no', debug: false });

i18next
    .use(initReactI18next)
    .use(LanguageDetector)
    .init({
        resources,
        lng: "en",
        fallbackLng: "en",
        debug: false,
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        supportedLngs: ["en", "ar", "fr"],
    });

export default i18next;
